import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/BlogBanner/BlogBanner.js
const BlogBanner = createSectionForm({
  icon: "article-line",
  title: "Blog Banner",
  fields: [{ name: "title", label: "Title", placeholder: "Blog Listing" }],
});

export default BlogBanner;
